{
  "schedule-date-time":"Schedule Date / Time",
  "cancel":"Cancel",
  "schedule-meeting":"Schedule Meeting",
  "details":"Details",
  "attendees":"Attendees",
  "schedule-closing":"Schedule Closing",
  "date":"Date",
  "start":"Start",
  "end":"End",
  "re-schedule-meeting":" Re-schedule Meeting",
  "you-have-no-meetings":"You have no meetings scheduled yet",
  "here-you-will":"Here you will see the details of your next meeting.",
  "add-attendee":"Add Attendee",
  "not-email":"The user doesn't have an email",
  "confirm-signature-request": "Confirm Request for Electronic Signature",
  "document-for-ron": "Document for RON",
  "document-signature-request-send": "Document signature request were successfully sent",
  "copy-url": "Copy url",
  "verify-attendees-message": "Please verify that you have the email address for all attendees on the",
  "parties-link": "Parties",
  "screen-suffix": "screen",
  "scheduleDateTimeLabel": "Schedule Date / Time",
  "attendee-name": "Name",
  "attendee-email": "Email",
  "attendee-url": "URL",
  "attendee-roles": "Roles",
  "attendee-add": "Add",
  "attendee-remove": "Remove",
  "attendee-add-aria": "Add {{name}} ({{email}}) to attendees",
  "attendee-remove-aria": "Remove {{name}} ({{email}}) from attendees",
  "attendee-move-to-attendees-aria": "Move {{name}} ({{email}}) to attendees",
  "attendee-move-to-parties-aria": "Move {{name}} ({{email}}) to parties",
  "attendee-actions": "Actions",
  "meeting-updated": "Meeting Updated",
  "attendees-selected": "{{count}} selected",
  "no-parties-match": "No parties match your search"
}